<div class="container">

  <div class="head">
    <div class="head-label">{{ (isEditMode ? 'MENU.EDIT_GROUP' : 'MENU.CREATE_GROUP') | translate}}</div>
    <mat-icon (click)="exit()" class="head-exit">close</mat-icon>
  </div>

  <main>

    <div class="left">
      <form [formGroup]="form"  (ngSubmit)="submit()">
        <div class="form-group">
          <div class="group-data">
            <mat-form-field>
              <mat-label>{{'MENU.NAME' | translate}}</mat-label>
              <input matInput formControlName="groupName" [class.isDifferent]="isGroupNameDifferent()"
                     (blur)="updateChangesInformationMessage()">
              <mat-icon *ngIf="isGroupNameDifferent()" matSuffix mat-icon-button aria-label="Clear"
                        matTooltip="{{originalGroup?.name}}" (click)="clearGroupName()">restore
              </mat-icon>
            </mat-form-field>

            <div *ngIf="data.organization.additionalLanguages">
              <mat-form-field *ngFor="let lang of data.organization.additionalLanguages">
                <mat-label>{{'MENU.NAME' | translate}} {{lang}}</mat-label>
                <input matInput formControlName="groupName{{lang}}"
                       [class.isDifferent]="isGroupNameTranslationDifferent(lang)"
                       (blur)="updateChangesInformationMessage()">
                <mat-icon *ngIf="isGroupNameTranslationDifferent(lang)" matSuffix mat-icon-button aria-label="Clear"
                          matTooltip="{{getOriginalNameTranslation(lang)}}" (click)="clearGroupNameTranslation(lang)">
                  restore
                </mat-icon>
              </mat-form-field>
            </div>

            <mat-form-field>
              <mat-label>{{'MENU.DESCRIPTION' | translate}}</mat-label>
              <input matInput formControlName="groupDescription" [class.isDifferent]="isGroupDescriptionDifferent()"
                     (blur)="updateChangesInformationMessage()">
              <mat-icon *ngIf="isGroupDescriptionDifferent()" matSuffix mat-icon-button aria-label="Clear"
                        matTooltip="{{originalGroup?.description}}" (click)="clearGroupDescription()">restore
              </mat-icon>
            </mat-form-field>

            <div *ngIf="data.organization.additionalLanguages">
              <mat-form-field *ngFor="let lang of data.organization.additionalLanguages">
                <mat-label>{{'MENU.DESCRIPTION' | translate}} {{lang}}</mat-label>
                <input matInput formControlName="groupDescription{{lang}}"
                       [class.isDifferent]="isGroupDescriptionTranslationDifferent(lang)"
                       (blur)="updateChangesInformationMessage()">
                <mat-icon *ngIf="isGroupDescriptionTranslationDifferent(lang)" matSuffix mat-icon-button
                          aria-label="Clear" matTooltip="{{getOriginalDescriptionTranslation(lang)}}"
                          (click)="clearGroupDescriptionTranslation(lang)">restore
                </mat-icon>
              </mat-form-field>
            </div>
          </div>
          <app-select-image-field
            [image]="selectedGroupImgSrc"
            [overrideUrl]="overrideGroupImgSrc"
            [originalUrl]="originalGroup?.externalPictureUrl"
            [organizationId]="data.organizationId"
            (imageChanged)="onImageChanged($event)"
            [allowOverrides]="data.allowOverrides"
          ></app-select-image-field>
        </div>

        <app-tags-form-field-old
          [tags]="tags"
          [originalTags]="originalTags"
          (tagsChanged)="onTagsChanged($event)"
          (editModeChanged)="onEditModeChangedTags($event)"
          [allowOverrides]="data.allowOverrides"
        >
        </app-tags-form-field-old>

        <app-tags-form-field
          [tagIds]="data?.group?.tagIds ?? []"
          [organization]="data.organization"
          [menuSectionId]="data.menuSectionId"
          [menuId]="data.menuSections[0].menuId"
          (tagIdsChange)="onTagIdsChanged($event)"
          [allowOverrides]="data.allowOverrides"
        >
        </app-tags-form-field>
          <mat-checkbox
            formControlName="hasVipDish">
            {{ 'MENU.HAS_VIP_DISH' | translate }}
          </mat-checkbox>

        <mat-form-field class="input" *ngIf="data.allowOverrides">
          <mat-label [class.isDifferent]="isParentDifferent()">{{'MENU.SELECT_PARENT' | translate}}</mat-label>
          <mat-select [(value)]="parentId" formControlName="parentId" [class.bold]="isParentId(parentId)">
            <mat-option [value]="null" [class.bold]="isParentId(null)">ROOT</mat-option>
            <mat-option *ngFor="let groupOption of getGroupOptions()" [value]="groupOption.externalId" [class.bold]="isParentId(groupOption.externalId)">{{groupOption.name}}</mat-option>
          </mat-select>
          <mat-icon *ngIf="isParentDifferent()" matSuffix mat-icon-button aria-label="Clear" matTooltip="{{originalGroup.groupStructure.parentId}}"
                    (click)="dropParent()">restore
          </mat-icon>
        </mat-form-field>

        <!--RelatedProducts-->
        <app-related-products
          [allowOverrides]="data.allowOverrides"
          [organization]="data.organization"
          [relatedProductInfos]="data.group?.relatedProductsInfo ?? []"
          [subject]="data.group"
          [originalSubject]="data.originalGroup"
          [overridePosition]="overrideGroupPosition"
          [menuSectionId]="data.menuSectionId"
          [selectedMenuSections]="selectedMenuSections"
          (relatedProductsChanged)="onRelatedProductsChanged()"
        >
        </app-related-products>

        <app-changes-for-menus
          *ngIf="data.allowOverrides"
          [changesInformationMessage]="changesInformationMessage"
          [menuSections]="this.data.menuSections"
          [currentMenuSectionId]="this.data.menuSectionId"
          (menusSelected)="onMenuSelectedChanges($event)">
        </app-changes-for-menus>
        <button
          *ngIf="data.allowOverrides"
          mat-raised-button
          color="primary"
          class="submit"
          [class.has-changes]="form.touched || relatedProductsDirty"
          [disabled]="disableSubmit || form.invalid || (!form.touched && !relatedProductsDirty) || !data.allowOverrides"
        >{{'MENU.SAVE' | translate}}</button>
      </form>
    </div>

  </main>

</div>
